// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__13mEd","col":"CardReaderDesc_col__1K_vn","label":"CardReaderDesc_label__Pm5Sz"};